import React, { FC, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import styles from './home_carousel.module.scss';
import { AnimatedLink } from '../../../../../doctrine/components/animated-link/AnimatedLink';
import { MaterialIcon } from '../../../../../doctrine/components/material-icon/MaterialIcon';

type Props = {
  slides: Array<{
    job: string;
    link: string;
    picture: {
      url: string;
    };
    quote: string;
    name: string;
  }>;
  linkText: string;
};

export const HomeCarousel: FC<Props> = ({ slides, linkText }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideNumber = slides.length;

  return (
    <div className={styles.container}>
      <button
        className={styles.arrowButton}
        onClick={() =>
          setCurrentSlide(currentSlide =>
            currentSlide - 1 >= 0 ? currentSlide - 1 : slideNumber - 1,
          )
        }
      >
        <MaterialIcon name="keyboard_arrow_left" className={styles.arrowIcon} />
      </button>
      <Carousel
        selectedItem={currentSlide}
        className={styles.carousel}
        showStatus={false}
        showIndicators={false}
        showThumbs={false}
        showArrows={false}
        emulateTouch
        infiniteLoop
        autoPlay
        interval={5000}
      >
        {slides.map(item => (
          <div key={item.link} className={styles.slide}>
            <div className={styles.leftPane}>
              <div className={styles.text}>
                <div className={styles.quote}>
                  «{'\u00a0'}
                  {item.quote}
                  {'\u00a0'}»
                </div>
                <div className={styles.name}>{item.name}</div>
                <div className={styles.job}>{item.job}</div>
              </div>
              <span className={styles.link}>
                <AnimatedLink href={item.link}>{linkText}</AnimatedLink>
              </span>
            </div>
            <div className={styles.imageContainer}>
              <img className={styles.image} src={item.picture.url} />
            </div>
          </div>
        ))}
      </Carousel>
      <button
        className={styles.arrowButton}
        onClick={() =>
          setCurrentSlide(currentSlide => (currentSlide + 1) % slideNumber)
        }
      >
        <MaterialIcon
          name="keyboard_arrow_right"
          className={styles.arrowIcon}
        />
      </button>
    </div>
  );
};
